var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          {
            ref: "tableheader",
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c(
              "el-tabs",
              {
                model: {
                  value: _vm.loginType,
                  callback: function ($$v) {
                    _vm.loginType = $$v
                  },
                  expression: "loginType",
                },
              },
              _vm._l(_vm.headerNum, function (item, index) {
                return _c("el-tab-pane", {
                  key: index,
                  attrs: { label: item.name, name: item.type.toString() },
                })
              }),
              1
            ),
            _vm._v(" "),
            _vm.loginType === "2"
              ? _c("div", { staticClass: "business-msg" }, [
                  _c(
                    "div",
                    { staticClass: "form-data" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "merInfoForm",
                          staticClass: "demo-ruleForm",
                          attrs: {
                            model: _vm.merInfoForm,
                            rules: _vm.rules,
                            "label-width": "140px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "当前实体商品余额：",
                                prop: "servicePhone",
                              },
                            },
                            [_c("div", [_vm._v(_vm._s(_vm.merData.balance))])]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "预警阈值：",
                                prop: "warnBalance",
                              },
                            },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  min: 499,
                                  max: 10000,
                                  label: "警戒库存",
                                },
                                model: {
                                  value: _vm.merInfoForm.warnBalance,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.merInfoForm,
                                      "warnBalance",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "merInfoForm.warnBalance",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "预警电话：", prop: "warnPhone" },
                            },
                            [
                              _c("el-input", {
                                staticClass: "width100",
                                model: {
                                  value: _vm.merInfoForm.warnPhone,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.merInfoForm,
                                      "warnPhone",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "merInfoForm.warnPhone",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "预警开关：", prop: "isWarn" } },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": true,
                                  "inactive-value": false,
                                  "active-text": "开启",
                                  "inactive-text": "关闭",
                                },
                                model: {
                                  value: _vm.merInfoForm.isWarn,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.merInfoForm, "isWarn", $$v)
                                  },
                                  expression: "merInfoForm.isWarn",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handlerSubmit("merInfoForm")
                                    },
                                  },
                                },
                                [_vm._v("确定")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }